/**
 * loadingindicator.js
 * Created by dwarika on 03/16/2022.
 */
import React from 'react';
import Loader from '@ey/canvascoreservices/LoadingIndicator';

export default function LoadingIndicator(props) {
	return (
		<Loader
			{...props}
			theme={
				document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'light'
					? null : 'dark'
			}
		/>
	);
}
